import { get } from "lodash";

export const shouldShowMaxAdvance = loan => Boolean(get(loan, "additionalAdvances.maxAdvance"));

export const shouldShowAdditionalAdvanceAllocations = loan => Boolean(get(loan, "additionalAdvances.additionalAdvanceAllocations"));

export const shouldShowNoticeForAdvance = loan => Boolean(get(loan, "additionalAdvances.noticeForAdvance"));

export const shouldShowDrawFrequency = loan => Boolean(get(loan, "additionalAdvances.drawFrequency"));

export const shouldShowDrawThresholdInterval = loan => Boolean(get(loan, "additionalAdvances.drawThresholdInterval"));

export const shouldShowDrawConditions = loan => Boolean(get(loan, "additionalAdvances.drawConditions"));

export const shouldShowRequiredEquity = loan => Boolean(get(loan, "additionalAdvances.requiredEquity"));

export const shouldShowCompletion = loan => Boolean(get(loan, "additionalAdvances.completion"));

export const shouldShowCovenants = loan => Boolean(get(loan, "additionalAdvances.covenants"));

export const shouldShowRestorationRetainage = loan => Boolean(get(loan, "additionalAdvances.restorationRetainage"));

export const shouldShowDevelopmentFee = loan => Boolean(get(loan, "additionalAdvances.developmentFee"));

export const shouldShowBudgetCostOverruns = loan => Boolean(get(loan, "additionalAdvances.budgetCostOverruns"));

export const shouldShowChangeOrders = loan => Boolean(get(loan, "additionalAdvances.changeOrders"));

export const shouldShowMisc = loan => Boolean(get(loan, "additionalAdvances.misc"));
